import { BATTLE_STATES, COMMANDERS, TURN_STATES } from './store.d';

export const LevelInitialState = {
  data: {
    battleState: BATTLE_STATES.INITIAL,
    troopOwners: [COMMANDERS.PLAYER, COMMANDERS.COM],
    turnState: TURN_STATES.IDLE,
    tresures: {[COMMANDERS.PLAYER]: null, [COMMANDERS.COM]: null},
    players: [],
    checklistToGo: {
      gridElement: false
    },
    manaLevelsByPlayer: {
      [COMMANDERS.PLAYER]: {
        manaLevel: 0,
        maxManaLevel: 0,
      },
      [COMMANDERS.COM]: {
        manaLevel: 0,
        maxManaLevel: 0,
      },
    }
  },
  levels: {
  }
}